import { create } from "zustand";
import { persist } from "zustand/middleware";

import {Job, JobId, JobsState} from "@/types/jobs";

export const useJobsStore = create<JobsState>()(
  persist(
    (set) => ({
      jobs: {},

      setJob: (job) =>
        set((jobState) => {
          const existing = jobState.jobs[job.id];
          return {
            jobs: {
              ...jobState.jobs,
              [job.id]: existing ? { ...existing, ...job } : job,
            },
          };
        }),

      updateJob: (id, patch) =>
        set((jobState) => {
          const existing = jobState.jobs[id];
          if (!existing) return jobState;

          let changed = false;
          for (const [key, value] of Object.entries(patch)) {
            if ((existing as any)[key] !== value) {
              changed = true;
              break;
            }
          }
          if (!changed) return jobState;

          return {
            jobs: {
              ...jobState.jobs,
              [id]: { ...existing, ...patch },
            },
          };
        }),
      removeJob: (id) =>
        set((jobState) => {
          const next = { ...jobState.jobs };
          delete next[id];
          return { jobs: next };
        }),
      clearDoneJobs: () =>
        set((jobState) => {
          const next: Record<JobId, Job> = {};
          for (const [id, job] of Object.entries(jobState.jobs)) {
            if (job.state === "queued" || job.state === "running") next[id] = job;
          }
          return { jobs: next };
        }),
      clearAllJobs: () => set({ jobs: {} }),
    }),
    { name: "jobs" }
  )
);
